module.exports = __webpack_public_path__ + "img/pic-list2.0cf770e4.jpg";